import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

export function CellPrice<TData, TValue>({ getValue }: CellContext<TData, TValue>) {
    const value = getValue() as number;
    const { formatNumber } = useIntl();
    if (value == null) return null;

    //TODO: this currency needs to be dynamic
    return (
        <span>
            {formatNumber(value / 100, {
                style: 'currency',
                currency: 'BGN',
            })}
        </span>
    );
}
